import React, { useState } from 'react'
import UploadFile from './upload-file'
import { CONST_GOOGLE_SHEET_IDS } from '../../../../constants'

const FinanceImport = ({ onUploadFile }) => {
	const [vendor, setVendor] = useState(null)

	const vendors = [
		{
			sheetId: CONST_GOOGLE_SHEET_IDS.MX_UPLOAD_ABC_INVOICES,
			imagePath: '/images/abc.png',
			name: 'ABC',
			title: 'UPLOAD ABC INVOICES',
		},
		{
			sheetId: CONST_GOOGLE_SHEET_IDS.MX_UPLOAD_MID_ATLANTIC_INVOICES,
			imagePath: '/images/mid-atlantic.png',
			name: 'MID-ATLANTIC',
			title: 'UPLOAD MID ATLANTIC INVOICES',
		},
		{
			sheetId: CONST_GOOGLE_SHEET_IDS.MX_UPLOAD_SPEC_INVOICES,
			imagePath: '/images/spec.png',
			name: 'SPEC',
			title: 'UPLOAD SPEC INVOICES',
		},
		{
			sheetId: CONST_GOOGLE_SHEET_IDS.MX_UPLOAD_CITIZENS_TRANSACTIONS,
			imagePath: '/images/citizens.png',
			name: 'CITIZENS CARD',
			title: 'UPLOAD COMM CARD TX - dev - not ready',
		},
	]

	return (
		<>
			<div className='flex flex-wrap items-center justify-center mx-auto'>
				{vendors.map((v, idx) => (
					<button
						onClick={() =>
							setVendor((prev) => (prev?.sheetId === v.sheetId ? null : v))
						}
						key={`${idx}sdf${new Date().toISOString()}`}
						className='mx-2 my-2'
					>
						<img
							src={v.imagePath}
							alt={v.name}
							className='rounded-theme-rounding overflow-clip w-[200px] h-[100px] bg-white p-2'
						/>
					</button>
				))}
			</div>
			{vendor && (
				<div>
					<div className=' dark:text-white font-semibold text-xl  text-center justify-center items-center p-4'>
						{vendor.title}
					</div>
					<div className='w-80 mx-auto'>
						<UploadFile sheetId={vendor.sheetId} onUploadFile={onUploadFile} />
					</div>
					{/* <div className=' dark:text-white font-semibold text-xl  text-center justify-center items-center p-4'>
						UPLOAD ABC INVOICES
					</div>
					<UploadFile
						sheetId={CONST_GOOGLE_SHEET_IDS.MX_UPLOAD_ABC_INVOICES}
						onUploadFile={onUploadFile}
					/>
					<div className=' dark:text-white font-semibold text-xl  text-center justify-center items-center p-4'>
						UPLOAD MID ATLANTIC INVOICES
					</div>
					<UploadFile
						sheetId={CONST_GOOGLE_SHEET_IDS.MX_UPLOAD_MID_ATLANTIC_INVOICES}
						onUploadFile={onUploadFile}
					/>
					<div className=' dark:text-white font-semibold text-xl  text-center justify-center items-center p-4'>
						UPLOAD SPEC INVOICES
					</div>
					<UploadFile
						sheetId={CONST_GOOGLE_SHEET_IDS.MX_UPLOAD_SPEC_INVOICES}
						onUploadFile={onUploadFile}
					/> */}
				</div>
			)}
		</>
	)
}

export default FinanceImport
